import ArticleStorage from "../../article/js/ArticleStorage";

// check for recent article and render list
var selector = ".article__results";
if (document.querySelector(selector)) {
  const articles = new ArticleStorage();
  articles.renderArticles();
}

var button = document.querySelector(".skip-link");
if (button) {
  button.addEventListener("click", (e) => {
    e.preventDefault();
    document.querySelector("#explore-resources").scrollIntoView({
      behavior: "smooth",
    });
  });
}
